import React from 'react';
import { filter, get, includes, map, keyBy, toPairs, reduce, reverse, sum } from 'lodash';
import moment from 'moment';
import PubSub from '../src/services/PubSub';
import Filters from '../src/components/sections/Resume/Filters';
import { Text, HasPermissions, Loading, StatsBox, StatsBoxContainer, FillRateTag, Container, Main, FlexContainer, NotFound, Row } from '../src/components/common';
import { AppImages, MediaListener } from '../src/components/utils';
import GetPickingStoreStats from '../src/components/graphql/getPickingStoreStats';

class PickingResume extends React.Component {
    constructor (props) {
        super(props);
        this.state = { filtersApplied: false, filters: { salesChannels: [] } };
    }

    componentDidMount () {
        PubSub.dispatch('SET_CENTER_HEADER', () => this.leftHeader());
    }

    componentWillUnmount () {
        PubSub.dispatch('SET_CENTER_HEADER', () => '');
    }

    leftHeader = () => {
        return (
            <FlexContainer align='center'>
                <Text text={moment().format('LL')} style={{ fontSize: '1.25em', color: '#333333', paddingLeft: '7px' }} />
            </FlexContainer>
        );
    }

    _getSalesChannels = () => {
        const salesChannel = get(this.props, 'session.salesChannels', []);
        const filterSalesChannelByKind = filter(salesChannel, ({ kind }) => kind === 'SPID35');
        return filterSalesChannelByKind;
    }

    _getFilterInitialValues = () => {
        const filters = {
            dateSelected: [
                moment(),
                moment().add('1', 'days')
            ],
            salesChannels: map(this._getSalesChannels(), ({ store, name }) => ({ label: name, value: store }))
        };

        return filters;
    }

    _onSubmitFilters = (values) => {
        const { dateSelected } = values;
        const filters = {
            salesChannels: filter(this._getSalesChannels(), ({ id }) => includes(map(get(values, 'salesChannels'), 'value'), id)),
            dateSelected
        };
        this.setState({ filtersApplied: true, filters });
    }

    _getVariables = () => {
        const { filtersApplied, filters } = this.state;
        const variables = {
            input: {
                idStore: filtersApplied ? map(get(filters, 'salesChannels'), 'store') : map(this._getSalesChannels(), 'store'),
                selectedSLA: 'express',
                initDate: moment(filtersApplied ? get(filters, 'dateSelected.init') : new Date()).format('YYYY-MM-DD'),
                endDate: moment(filtersApplied ? get(filters, 'dateSelected.end') : new Date()).add(1, 'days').format('YYYY-MM-DD')
            }
        };
        return variables;
    }

    _formatQueryResponse = (data) => {
        const { filtersApplied, filters } = this.state;

        const storeStats = (data, store) => {
            const { idStore, __typename, ...stats } = get(data, store, {});
            return toPairs(stats); // example: {facturado: 0} -> ['facturado', 0]
        };

        // applies a sum over [status, value, ...]
        const statsTotals = (items) => reduce(items, (acc, [_, value]) => {
            return acc + parseInt(value);
        }, 0);

        const resultsBySalesChannel = map(this._getSalesChannels(), ({ store, ...salesChannel }) => {
            return {
                ...salesChannel,
                store,
                totals: statsTotals(storeStats(data, store)),
                stats: reverse(storeStats(data, store))
            };
        });

        const totalBoxs = filtersApplied
            ? filter(resultsBySalesChannel, ({ store }) => includes(map(get(filters, 'salesChannels'), 'store'), store))
            : resultsBySalesChannel;

        const totalResults = toPairs({
            'facturado': sum(map(data, 'facturado')),
            'pickeadoPorFacturar': sum(map(data, 'pickeadoPorFacturar')),
            'cancel': sum(map(data, 'cancel')),
            'pendienteAuditoria': sum(map(data, 'pendienteAuditoria')),
            'inPicking': sum(map(data, 'inPicking')),
            'pedientePicking': sum(map(data, 'pedientePicking'))
        });

        const totalsResume = {
            id: '-1',
            name: 'resume.order_status.totals',
            totals: statsTotals(totalResults),
            stats: reverse(totalResults)
        };

        return [totalsResume, ...totalBoxs];
    }

    render () {
        return (
            <HasPermissions
                to={['express-monitor:view']}
                otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
            >
                <Container >
                    <Main background='f4f4f4' withFooter>
                        <HasPermissions {...this.props} to={['express-monitor:filter&search']} >
                            <MediaListener values={['40%', '100%', '100%']}>
                                {({ currentValue }) => (
                                    <Filters
                                        fromResume
                                        currentValue={currentValue}
                                        onSubmitFilters={values => this._onSubmitFilters(values)}
                                        exclude={['status', 'slas']}
                                        withoutStoreKind
                                    />
                                )}
                            </MediaListener>
                        </HasPermissions>
                        <GetPickingStoreStats variables={this._getVariables()} pollInterval={60000}>
                            {({ loading, data, networkStatus }) => (
                                <Loading loading={networkStatus === 6 ? false : loading}>
                                    <Row backgroundColor='#f4f4f4' paddingHorizontal={13} paddingVertical={0}>
                                        {map(this._formatQueryResponse(keyBy(data, 'idStore')), ({ id, name, stats, icon, totals }, index) => (
                                            <StatsBox key={`stats-box-picking-resume-${index + 1}`} width={['90%', '50%', '25%']}>
                                                <StatsBoxContainer flex={1} direction='column' >
                                                    {/** Card Title */}
                                                    <FlexContainer style={{ borderBottom: '1px solid #eaeaea', minHeight: '32px' }} align='center'>
                                                        {id !== '-1' && <AppImages name={icon} style={{ marginRight: '10px' }} />}
                                                        <Text text={name} size={14} strong />
                                                        <FillRateTag style={{ marginLeft: 'auto' }} background={'#f4f4f4'} color='black'>
                                                            <Text text={String(totals)} size={11} strong />
                                                        </FillRateTag>
                                                    </FlexContainer>

                                                    {/** Card Body  */}

                                                    <FlexContainer flex={1} direction='column'>
                                                        { map(stats, ([label, value], key) => ( // status, value
                                                            <FlexContainer align='center' key={key} flex={1} style={{ borderBottom: '1px solid #eaeaea', padding: '5px 0px' }}>
                                                                <Text text={`resume.order_status.${String(label).toLowerCase()}`} style={{ fontSize: '.75rem' }} />
                                                                <FillRateTag style={{ marginLeft: 'auto' }} background={id !== '-1' ? 'transparent' : '#f4f4f4'} color='black'>
                                                                    <Text text={String(value)} strong />
                                                                </FillRateTag>
                                                            </FlexContainer>
                                                        ))}
                                                    </FlexContainer>
                                                </StatsBoxContainer>
                                            </StatsBox>
                                        ))}
                                    </Row>
                                </Loading>
                            )}
                        </GetPickingStoreStats>
                    </Main>
                </Container>
            </HasPermissions>
        );
    }
}

export default PickingResume;
